import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import useAuth from 'context/useAuth';

import ErrorView from 'components/errors/ErrorView';
import Profile from 'components/profile/Profile';
import OverlaySpinner from 'components/spinner/OverlaySpinner';
import { getProfile } from 'services/AccountService';

const ProfilePage = () => {
    const [error, setError] = useState(null);
    const [isFetchingProfile, setIsFetchingProfile] = useState(false);
    const { setUserProfile, userProfile } = useAuth();

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                setIsFetchingProfile(true);
                const res = await getProfile();
                setUserProfile(res);
            } catch (e) {
                setError('general.unexpectedErrorOccurred');
            } finally {
                setIsFetchingProfile(false);
            }
        };

        if (!userProfile) {
            fetchUserProfile();
        }
    }, [userProfile]);

    if (isFetchingProfile) return <OverlaySpinner />;

    return (
        <Box className="home-page grey-banner" maxWidth="false">
            {error ? (
                <Box sx={{ textAlign: 'center' }}>
                    <ErrorView error={error} />
                </Box>
            ) : (
                userProfile && <Profile />
            )}
        </Box>
    );
};

export default ProfilePage;
